import React, { FC, memo } from 'react';
import { Stack } from '@mui/material';
import { StyledBox, StyledDetailsHolder, StyledTitle } from './styled';
import { HeaderParams } from './types';

const PageHeader: FC<HeaderParams> = ({ title, actions, details }) => {
  return (
    <StyledBox gap={2}>
      <Stack
        flexGrow={2}
        flexWrap='wrap'
        flexShrink={{
          lg: 0,
        }}
        gap={1}
        direction='row'
        alignItems='center'
      >
        <StyledTitle data-test={`${title}-title`}>{title}</StyledTitle>

        <StyledDetailsHolder>{details}</StyledDetailsHolder>
      </Stack>

      <Stack alignItems='center' justifyContent='end'>{actions}</Stack>
    </StyledBox>
  );
};

export default memo(PageHeader);
